import React from 'react';
import { Screen } from 'src/components/screen';
import { ReportsProvider } from './reports-context';
import { ReportsContainer } from './container';

const ReportsScreen: React.FC = () => {
  return (
    <ReportsProvider>
      <Screen>
        <ReportsContainer />
      </Screen>
    </ReportsProvider>
  );
};

export { ReportsScreen };
